import { format } from '../utils/formatCurrency';
import { sleep } from '../utils/sleep';

export default class Utils {
  constructor() {

  }

  format(value, decimals, hideFractionIfPossible, separator) {
    return format(value, decimals, hideFractionIfPossible, separator);
  }

  checkSubmoduleBrunchName(branchName, submoduleName) {
    if (!window.submoduleBrunchNames) {
      throw Error('The file submoduleConfigs.js is not imported into the project')
    }
    if (window.submoduleBrunchNames[submoduleName] !== branchName) {
      window.OPUtility.messageWindow.showError(window.OPUtility.errorTypes.WRONG_SUBMODULE_BRUNCH.CODE, `${submoduleName}: wrong submodule brunch, use "${window.submoduleBrunchNames[submoduleName]}" or change submoduleConfigs.js`);
    }
  }

  sleep(...arg) {
    return sleep(...arg);
  }
}
